import React, { useState } from "react";
import { FormControl, FormGroup, HelpBlock, ControlLabel } from "react-bootstrap";
import LoaderButton from "../components/LoaderButton";
import { useFormFields } from "../libs/hooksLib";
import { resetPassword, confirmResetPassword } from 'aws-amplify/auth';
import "./ForgotPassword.css";

export default function ForgotPassword(props) {
    const [fields, handleFieldChange] = useFormFields({
        email: "",
        password: "",
        confirmPassword: "",
        confirmationCode: ""
    });
    const [confirmationCodeSent, setConfirmationCodeSent] = useState(false);
    const [invalidEmail, setInvalidEmail] = useState(false);
    const [changePasswordError, setChangePasswordError] = useState("");
    const [isLoading, setIsLoading] = useState(false);

    async function handleForgotPassword(event){
        event.preventDefault();

        setIsLoading(true);

        try {
            console.log('Requesting password reset for:', fields.email);
            const result = await resetPassword({ username: fields.email });
            console.log('Reset password result:', result);
            
            // Show where the code was sent
            if (result && result.destination) {
                alert(`Verification code sent to ${result.destination}. Please check your email (including spam folder).`);
            } else {
                alert('Verification code sent! Please check your email (including spam folder).');
            }
            
            setConfirmationCodeSent(true);
            setIsLoading(false);
            setInvalidEmail(false);
        } catch (e) {
            console.error('Password reset error:', e);
            alert(e.message || 'Failed to send verification code');
            setInvalidEmail(true);
            setIsLoading(false);
        }
    }

    async function handleForgotPasswordSubmit(event) {
        event.preventDefault();

        setIsLoading(true);

        try {
            console.log('Confirming password reset for:', fields.email);
            await confirmResetPassword({
                username: fields.email,
                confirmationCode: fields.confirmationCode,
                newPassword: fields.password
            });
            console.log('Password reset successful');
            setIsLoading(false);
            setChangePasswordError("");
            alert('Password reset successful! Please login with your new password.');
            props.history.push("/login");
        } catch (e) {
            console.error('Password reset confirmation error:', e);
            alert(e.message || 'Failed to reset password');
            setIsLoading(false);
            setChangePasswordError(e.message);
        }
    }

    function validateForgotPasswordForm(){
        return fields.email.length > 0;
    }

    function validateForgotPasswordSubmitForm() {
        return (
          fields.confirmationCode.length > 0 &&
          fields.password.length > 0 &&
          fields.password === fields.confirmPassword
        );
      }

    function renderForgotPasswordForm() {
        return (
            <form onSubmit={handleForgotPassword}>
                <FormGroup controlId="email" bsSize="large">
                    <ControlLabel>Email</ControlLabel>
                    <FormControl
                        autoFocus
                        type="email"
                        value={fields.email}
                        onChange={handleFieldChange}
                    />
                </FormGroup>
                {
                    invalidEmail === true? (<HelpBlock className="invalid-email">*Invalid email</HelpBlock>):''
                }
                <LoaderButton
                    block
                    type="submit"
                    bsSize="large"
                    className="ResetPasswordButton"
                    isLoading={isLoading}
                    disabled={!validateForgotPasswordForm()}
                >
                    Send verification code
                </LoaderButton>
            </form>
        );
    }

    function renderForgotPasswordSubmitForm() {
        return (
            <form onSubmit={handleForgotPasswordSubmit}>
                <FormGroup controlId="confirmationCode" bsSize="large">
                    <ControlLabel>Confirmation Code</ControlLabel>
                    <FormControl
                        autoFocus
                        type="tel"
                        onChange={handleFieldChange}
                        value={fields.confirmationCode}
                        disabled={!confirmationCodeSent}
                    />
                    <HelpBlock>Please check your email for the code.</HelpBlock>
                </FormGroup>
                <FormGroup controlId="password" bsSize="large">
                    <ControlLabel>New Password</ControlLabel>
                    <FormControl
                        type="password"
                        value={fields.password}
                        onChange={handleFieldChange}
                    />
                </FormGroup>
                <FormGroup controlId="confirmPassword" bsSize="large">
                    <ControlLabel>Confirm Password</ControlLabel>
                    <FormControl
                        type="password"
                        onChange={handleFieldChange}
                        value={fields.confirmPassword}
                    />
                </FormGroup>
                <LoaderButton
                    block
                    type="submit"
                    bsSize="large"
                    className="ResetPasswordSubmitButton"
                    isLoading={isLoading}
                    disabled={!validateForgotPasswordSubmitForm()}
                >
                    Submit
                </LoaderButton>
                {
                    changePasswordError.length > 0? (<HelpBlock className="invalid-email">{changePasswordError}</HelpBlock>):''
                }
            </form>
        )
    }

    return (
        <div className="Login">
            {/* {newUser === null ? renderForm() : renderConfirmationForm()} */}
            {confirmationCodeSent === false ? renderForgotPasswordForm() : renderForgotPasswordSubmitForm()}
        </div>
    );
}